var React = require('react');

function IconMessageSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM128 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"}));
}

IconMessageSolid.defaultProps = {"viewBox":"0 0 512 512","fill":"currentColor"};

module.exports = IconMessageSolid;

IconMessageSolid.default = IconMessageSolid;
